import React from "react";

import Fab from "@material-ui/core/Fab";
import CallIcon from "@material-ui/icons/Call";
import Tooltip from "@material-ui/core/Tooltip";

import "./style.css";

function FloatingIcon({ content }) {
  return (
    <Tooltip title="Schedule a meeting" placement="left" arrow>
      <Fab color="primary" className="floating__icon">
        <CallIcon />
      </Fab>
    </Tooltip>
  );
}

export default FloatingIcon;
